<template>
    <div class="common-selected-tree">
        <treeselect
            :disabled="isRead"
            :options="sourceOptions"
            :multiple="multiple"
            :flat="flat"
            v-model="value"
            :normalizer="normalizer"
            :openDirection="openDirection"
            @input="onInput"
            :value-consists-of="valueConsistsOf"
            :flatten-search-results="false"
            :disable-branch-nodes=disableBranchNodes
            noResultsText="没有匹配值"
            noOptionsText="没有选项"
            :placeholder="placeholder">
            <div slot="option-label" slot-scope="{ node }" class="treeselect-span-ellipsis" >
              <span :title="node.label">  {{ node.label }}</span>
            </div>
            <div slot="value-label" slot-scope="{ node }"  >
              <span :title="node.label">{{ node.label }}</span>
            </div> 
        </treeselect>
    </div>
</template>

<script>
  import Treeselect from '@riophae/vue-treeselect';
  import '@riophae/vue-treeselect/dist/vue-treeselect.css';
  export default {
      components: { Treeselect },
      data () {
          return {
              value: null,
              myMap: new Map()
          };
      },
      props: {
          sourceOptions: { // 外部传入的下拉列表的结构数据
              type: Array
          },
          multiple: {
              type: Boolean,
              default: true
          },
          openDirection: {
              type: String,
              default: 'auto'
          },
          disableBranchNodes: {
              type: Boolean,
              default: false
          },
          flat: {
              type: Boolean,
              default: false
          },
          valueConsistsOf: {// ALL:所有 BRANCH_PRIORITY:分支优先 LEAF_PRIORITY:叶优先 ALL_WITH_INDETERMINATE:一切都是不确定的
              type: String,
              default: 'LEAF_PRIORITY'
          },
          isRead: {
              type: Boolean,
              default: false
          },
          placeholder: {
              type: String,
              default: '选择'
          },
          callbackParam: {
              type: Object
          },
          source: {
              type: Number
          },
          sourceType: {
              type: Number
          },
          modelId: {
              type: String
          }
      },
      created () {
          if (this.modelId) {
              this.value = this.modelId;
          }
          // this.$nextTick(async () => {
          //     this.setDefaultInputStyle();
          // });
      },
      methods: {
          setDefaultInputStyle () {
              this.$el.querySelector('.vue-treeselect__input').style = {
                  'width': '100%',
                  'white-space': 'nowrap',
                  'text-overflow': 'ellipsis',
                  'display': 'block'
              };
          },
          initParam (modelSources) {
              if (modelSources) {
                  this.value = modelSources;
              }
          },
          clearSelect () {
              this.value = null;
          },
          normalizer (node) { // 本地缓存key，value对应
              this.myMap.set(node.id + '', node);
          },
          onInput (value, instanceId) { // 选中下拉节点后触发的事件
              let selected;
              if (this.multiple) {
                  selected = [];
                  value.forEach((item) => {
                      selected.push(this.myMap.get(item + ''));
                  });
              } else {
                  selected = this.myMap.get(value);
              }
              if (this.callbackParam) {
                  if (this.source === 1) {
                      this.$emit('treeSelectChoose', selected, this.callbackParam, this.sourceType);
                  }
              } else {
                  this.$emit('treeSelectChoose', selected);
              }
          }
      }
  };
</script>
<style lang="less" scoped="scoped">
  .common-selected-tree{
    .treeselect-span-ellipsis {
      width: 100%;
      /* overflow: hidden; */
      white-space: nowrap;
      text-overflow: ellipsis;
      display: block;
    }
  }

</style>


// WEBPACK FOOTER //
// src/components/TreeSelect/TreeSelect.vue